import { useEffect } from 'react';
import { useDependencies } from './useDependencies';
import { useSelector } from 'react-redux';
import { selectOpenAiDescriptionForRule } from '../../../../reducers/documentation/documentationReducer';
import { SWEEP_ELEMENTS } from '../helpers';
import { ConfigurationItem } from '../../../parser/ParserTypes';
import { FIELD, OBJECT } from '@server/parser';

export const useInitializeOpenAiDescriptionForRule = ({
  configurationItem,
  crmOrgId,
  type,
}: {
  configurationItem: ConfigurationItem;
  crmOrgId: string;
  type: string;
}) => {
  const { getOpenAiDescriptionForRule } = useDependencies(crmOrgId);
  const { id, metadataId } = configurationItem ?? {};
  const openAiDescription = useSelector(selectOpenAiDescriptionForRule(id, crmOrgId));
  const isSweepElement = SWEEP_ELEMENTS.includes(type);

  useEffect(() => {
    const isNotFieldType = type && type !== FIELD;
    const isNotObjectType = type && type !== OBJECT;

    if (
      !openAiDescription &&
      id &&
      isNotObjectType &&
      isNotFieldType &&
      !isSweepElement
      // ||
      //isValidStateForOthers) todo
    ) {
      getOpenAiDescriptionForRule({
        ruleId: id,
        crmOrgId,
        metadataId: metadataId ?? '',
      });
    }
  }, [
    crmOrgId,
    openAiDescription,
    getOpenAiDescriptionForRule,
    type,
    id,
    isSweepElement,
    metadataId,
  ]);
};
